import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Avatar, Chip, Typography, CircularProgress, InputAdornment, TextField, IconButton, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import MyTable from '../../components/Schedule/MyTable';
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import MyStationChecklistCard from './MyStationChecklistCard';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';

const MyStationChecklist = () => {
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState("")
    const [searchResult, setSearchResult] = useState('');
    const [duration, setDuration] = useState('');
    const [checklistType, setChecklistType] = useState('');
    const [viewType, setViewType] = useState("card");
    const [allChecklist, setAllChecklist] = useState([])
    const [checklistDetails, setChecklistDetails] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [listType, setListType] = useState('Upcoming')
    const [pastCount, setPastCount] = useState(0)
    const [upcomingCount, setUpcomingCount] = useState(0)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [openCategories, setOpenCategories] = useState({})
    const [locationDrop, setLocationDrop] = useState([])
    const [selectedStation, setSelectedStation] = useState("all")

    const columns = [
        {
            field: 'title', headerName: 'Title', flex: 1, minWidth: 160, valueGetter: (params) => params.row.checklist?.title
        },
        {
            field: 'assigned', headerName: 'Assigned by', flex: 1, minWidth: 180, valueGetter: (params) => params.row.checklist?.employee_full_name
        },
        {
            field: 'created_on', headerName: 'Due Date', flex: 1, minWidth: 200, renderCell: (params) => {
                return (
                    <div className={(params?.row?.status == 'pending' && listType == "Past") && 'red-font'}>
                        {varFormatTime(params.row.checklist_date, user?.Time_Format)}
                    </div>
                );
            }
        },
        {
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 350,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        {/* Checklists */}
                        <Chip
                            variant="outlined"
                            sx={{
                                backgroundColor: '#EAECF0',
                                color: '#2B3F6C',
                                border: '1px solid #2B3F6C',
                                cursor: 'pointer'
                            }}
                            avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
                            label={'Checklists'}
                            onClick={() => {
                                setShowModal(true)
                                setTitle(params.row?.checklist?.title)
                                getChecklistDetails(params?.row?.checklist_id)
                            }}
                        />

                        {/* Fill */}
                        {params?.row?.status == "pending" ?
                            <Link style={{ pointerEvents: params.row.is_filled === 0 ? 'none' : 'auto' }} to={`/firehouse/my-station-checklist-item/${params?.row?.checklist_id}/${params?.row?.id}`}>
                                <Chip
                                    variant="outlined"
                                    sx={{
                                        backgroundColor: params.row.is_filled === 0 ? '#D0D5DD' : '#BF1D2D',
                                        color: '#F5F5F5',
                                        border: params.row.is_filled === 0 ? ' none' : '1px solid #BF1D2D',
                                        cursor: 'pointer'
                                    }}
                                    avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                    label={'Fill'}
                                    disabled={params.row.is_filled === 0}
                                />
                            </Link>
                            :
                            params?.row?.status == "completed" ?
                                <Link to={`/firehouse/my-station-checklist-item/${params?.row?.checklist_id}/${params?.row?.id}`}>
                                    <Chip
                                        variant="outlined"
                                        sx={{
                                            backgroundColor: '#01784F',
                                            color: '#F5F5F5',
                                            border: '1px solid #01784F',
                                            cursor: 'pointer'
                                        }}
                                        avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                        label={'Filled'}
                                    />
                                </Link>

                                :
                                params?.row?.status == "started" ?
                                    <Link
                                        to={{
                                            pathname: `/firehouse/my-station-checklist-item/${params?.row?.checklist_id}/${params?.row?.id}`,
                                        }}
                                        state={{ title: params?.row?.checklist?.title }}>
                                        <Chip
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: '#BF1D2D',
                                                color: '#F5F5F5',
                                                border: '1px solid #BF1D2D',
                                                cursor: 'pointer'
                                            }}
                                            avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                            label={'Resume Filling'}
                                        />
                                    </Link>
                                    :
                                    params?.row?.status == "failed" ?
                                        <Link to={`/firehouse/my-station-checklist-item/${params?.row?.checklist_id}/${params?.row?.id}`}>
                                            <Chip
                                                variant="outlined"
                                                sx={{
                                                    backgroundColor: '#2E3238',
                                                    color: '#F5F5F5',
                                                    border: '1px solid #2E3238',
                                                    cursor: 'pointer'
                                                }}
                                                avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                label={'Failed'}
                                            />
                                        </Link>
                                        :
                                        <Chip
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: '#BF1D2D',
                                                color: '#F5F5F5',
                                                border: '1px solid #BF1D2D',
                                                cursor: 'pointer'
                                            }}
                                            avatar={<Avatar src="/images/fill1.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                            label={'Error'}
                                        />
                        }
                    </Box>
                );
            },
        }
    ]

    const getChecklist = (loader = true) => {
        const body = {
            'limit': itemsPerPage,
            'page': currentPage,
            'search': searchResult,
            'type': listType
        }
        if (loader) {
            setLoading(true)
        }
        ApiService.post('/checklist-user/getMyStationChecklist', body)
            .then((data) => {
                setAllChecklist(data?.data)
                setTotalPages(Math.ceil(data?.total / data?.per_page));
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const getChecklistCount = (loader = true) => {
        if (loader) {
            setLoading(true)
        }
        ApiService.get('/checklist-user/getMyStationChecklistCount')
            .then(({ data }) => {
                setUpcomingCount(data?.upcoming_count)
                setPastCount(data?.past_count)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const getChecklistDetails = (id) => {
        ApiService.get(`/checklist/station-inspection/${id}`)
            .then(({ data }) => {
                const items = data?.data?.checklist_station_items || [];
                setChecklistDetails(items)
                setSelectedStation("all")
                // Default all categories to open
                const allOpen = items.reduce((acc, item) => {
                    acc[item.category || "No category"] = true;
                    return acc;
                }, {});
                setOpenCategories(allOpen)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const handlePageChange = (_, value) => {
        setCurrentPage(value);
    };

    useEffect(() => {
        getChecklist()
        getChecklistCount()
    }, [listType])

    useEffect(() => {
        getLocation()
    }, [])

    const getLocation = () => {
        ApiService.get('/checklist/location')
            .then(({ data }) => {
                const posArr = data?.data?.map((pos) => ({ label: pos.location_description, value: pos.id })) || [];
                setLocationDrop(posArr);
            })
            .catch(() => {});
    }

    const getLocationName = (id) => {
        if (!id) return "";
        const match = locationDrop.find(l => l.value == id);
        return match ? match.label : "";
    }

    useEffect(() => {
        getChecklist(false)
    }, [currentPage, searchResult, duration, checklistType])

    const uniqueStations = [...new Set((checklistDetails || []).map(i => i.location_id).filter(Boolean))];

    const filteredChecklistDetails = selectedStation === "all"
        ? checklistDetails
        : (checklistDetails || []).filter(i => i.location_id == selectedStation);

    const groupedChecklistDetails = filteredChecklistDetails && filteredChecklistDetails.length > 0 ? filteredChecklistDetails.reduce((acc, item) => {
        const key = item.category || "No category";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {}) : {};

    const toggleCategory = (category) => {
        setOpenCategories(prev => ({ ...prev, [category]: !prev[category] }));
    };

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            ) :
                (
                    <>
                        <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                            <Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px", marginLeft: "7px" }} >
                                {/* Heading */}
                                <Grid item xs={10} md={4}>
                                    <Typography variant="h5">My Station Checklist</Typography>
                                </Grid>

                                {/* Upcoming Chip Button */}
                                <Grid container item md={3} gap={2}>
                                    <Grid item xs={6} sm={6} md={6}>
                                        <div className={listType == 'Upcoming' ? 'tab-active' : 'tab-white'}
                                            onClick={() => {
                                                setListType('Upcoming')
                                                setSearchResult('')
                                            }}>
                                            {`Upcoming (${upcomingCount})`}
                                        </div>
                                    </Grid>
                                    {/* Past Chip Button */}
                                    <Grid item xs={6} sm={6} md={5}>
                                        <div className={listType == 'Past' ? 'tab-active' : 'tab-white'}
                                            onClick={() => {
                                                setListType('Past')
                                                setSearchResult('')
                                            }}>
                                            {`Past (${pastCount})`}
                                        </div>
                                    </Grid>
                                </Grid>
                                {/* List & Grid Icon */}
                                <Grid item xs={6} sm={6} md={1}>
                                    <div
                                        style={{
                                            height: "48px",
                                            border: "1px solid #EAECF0",
                                            borderRadius: "8px",
                                            marginLeft: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "48px",
                                                height: "48px",
                                                borderRight: "1px solid #EAECF0",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setViewType("card")}
                                        >
                                            <img
                                                src={viewType === "list" ? "/images/card-empty.svg" : "/images/card.svg"}
                                                height="22px"
                                                width="22px"
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "48px",
                                                height: "48px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setViewType("list")}
                                        >
                                            <img
                                                src={viewType === "list" ? "/images/listview.svg" : "/images/list-empty.svg"}
                                                height="20px"
                                                width="20px"
                                            />
                                        </div>

                                    </div>
                                </Grid>

                                {/* Search field */}
                                <Grid item xs={12} sm={12} md={3}>
                                    <TextField
                                        variant="outlined"
                                        placeholder="Search"
                                        onChange={(e) => setSearchResult(e.target.value)}
                                        className="w-100"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            sx: {
                                                height: '48px',
                                                fontSize: '14px',
                                                marginRight: '10px',
                                            },
                                        }}
                                    />
                                </Grid>

                            </Grid>

                            {(!allChecklist || allChecklist.length == 0) ?
                                <Box>
                                    {searchResult != '' ?
                                        <div className='mt-2 mx-2' style={{ color: '#555555' }}>
                                            No Search Results found.
                                        </div>
                                        :
                                        <div className='mt-2 mx-2' style={{ color: '#555555' }}>
                                            No Checklist available right now.
                                        </div>}

                                    <div className='inner-box d-flex align-items-center' style={{ height: 550 }}>
                                        <img src='/images/blur-logo.png' />
                                    </div>
                                </Box>
                                :
                                <>
                                    {viewType == "list" ?
                                        <div className='mt-4'>
                                            <MyTable
                                                rows={allChecklist}
                                                columns={columns}
                                                rowCount={allChecklist.length}
                                                checkboxSelection={false}
                                                hideFooter={true}
                                            />
                                        </div>
                                        :
                                        <>
                                            <Grid container style={{ marginTop: '3rem' }}>
                                                {allChecklist.map((item) => (
                                                    <MyStationChecklistCard item={item} setTitle={setTitle} getChecklistDetails={getChecklistDetails} setShowModal={setShowModal} listType={listType} />
                                                ))}
                                            </Grid>
                                        </>
                                    }
                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                        className="mt-4 d-flex"
                                        style={{ justifyContent: 'end' }}
                                    />
                                </>
                            }
                        </Paper >
                    </>
                )
            }

            {/* Checklist Pop-Up View */}
            <div className='font-fam'>
                <Modal show={showModal} size="lg" onHide={() => {
                    setShowModal(false)
                    setChecklistDetails([])
                }}>

                    <Modal.Header closeButton>
                        <Modal.Title>Checklist Details - {title}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ padding: 30 }}>
                        <Grid item xs={12} sm={6} md={6}>

                            <div>
                                {checklistDetails && checklistDetails.length > 0 && uniqueStations.length > 0 && (
                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16, overflowX: 'auto' }}>
                                        <div
                                            onClick={() => setSelectedStation("all")}
                                            style={{
                                                cursor: 'pointer',
                                                padding: '8px 16px',
                                                borderRadius: '999px',
                                                fontSize: 13,
                                                fontFamily: 'karla, sans-serif',
                                                userSelect: 'none',
                                                whiteSpace: 'nowrap',
                                                backgroundColor: selectedStation === "all" ? "#BF1D2D" : "#f0f0f0",
                                                color: selectedStation === "all" ? "#fff" : "#555",
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            All
                                        </div>
                                        {uniqueStations.map(stationId => (
                                            <div
                                                key={stationId}
                                                onClick={() => setSelectedStation(stationId)}
                                                style={{
                                                    cursor: 'pointer',
                                                    padding: '8px 16px',
                                                    borderRadius: '999px',
                                                    fontSize: 13,
                                                    fontFamily: 'karla, sans-serif',
                                                    userSelect: 'none',
                                                    whiteSpace: 'nowrap',
                                                    backgroundColor: selectedStation == stationId ? "#BF1D2D" : "#f0f0f0",
                                                    color: selectedStation == stationId ? "#fff" : "#555",
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                {getLocationName(stationId) || 'Unknown'}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {checklistDetails && checklistDetails.length > 0 ? (
                                    <div className='font-fam mt-2'>
                                        {Object.entries(groupedChecklistDetails).map(([category, items], index) => {
                                            const isOpen = openCategories[category];

                                            return (
                                                <div key={category} style={{ marginBottom: 16 }}>

                                                    {/* Category Header */}
                                                    <div
                                                        onClick={() => toggleCategory(category)}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            padding: '8px 4px',
                                                            borderBottom: '1px solid #e0e0e0',
                                                            userSelect: 'none'
                                                        }}
                                                    >
                                                        <span style={{
                                                            marginRight: 10, fontSize: 10, color: '#999',
                                                            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s ease',
                                                            display: 'inline-block'
                                                        }}>
                                                            ▶
                                                        </span>
                                                        <span style={{
                                                            minWidth: 22, height: 22, borderRadius: '50%',
                                                            background: '#BF1D2D', color: '#fff',
                                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                            fontSize: 11, fontWeight: 700, marginRight: 10, flexShrink: 0
                                                        }}>
                                                            {index + 1}
                                                        </span>
                                                        <span style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                                                            {category}
                                                        </span>
                                                        <span style={{ marginLeft: 8, fontSize: 12, color: '#aaa', fontWeight: 400 }}>
                                                            ({items.length} {items.length === 1 ? 'item' : 'items'})
                                                        </span>
                                                    </div>

                                                    {/* Child Items */}
                                                    <div style={{
                                                        maxHeight: isOpen ? 1000 : 0,
                                                        overflow: 'hidden',
                                                        transition: 'max-height 0.3s ease'
                                                    }}>
                                                        <div style={{
                                                            marginLeft: 16,
                                                            borderLeft: '2px solid #e0e0e0',
                                                            paddingLeft: 16,
                                                            marginTop: 8
                                                        }}>
                                                            {items.map((item, i) => (
                                                                <div
                                                                    key={item.id || i}
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'flex-start',
                                                                        gap: 10,
                                                                        padding: '8px 0',
                                                                        borderBottom: i < items.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                        position: 'relative'
                                                                    }}
                                                                    className='page-break-never print-all-data'
                                                                >
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        left: -16,
                                                                        top: 16,
                                                                        width: 12,
                                                                        height: 0,
                                                                        borderTop: '2px solid #e0e0e0'
                                                                    }} />

                                                                    <div style={{
                                                                        width: 6,
                                                                        height: 6,
                                                                        borderRadius: '50%',
                                                                        background: '#BF1D2D',
                                                                        marginTop: 5,
                                                                        flexShrink: 0
                                                                    }} />

                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        width: '100%',
                                                                        gap: 10
                                                                    }}>
                                                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                                            <p style={{
                                                                                margin: 0,
                                                                                fontSize: 13,
                                                                                color: '#555',
                                                                                lineHeight: 1.5
                                                                            }}>
                                                                                {item.description || (
                                                                                    <span style={{ color: '#ccc', fontStyle: 'italic' }}>
                                                                                        No description
                                                                                    </span>
                                                                                )}
                                                                            </p>
                                                                            {item.location_id && (
                                                                                <span style={{ fontSize: 12, color: '#2B3F6C', fontWeight: 500 }}>
                                                                                    Parent Station: <span style={{ fontWeight: 400, color: '#555' }}>{getLocationName(item.location_id) || '—'}</span>
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        <div style={{ display: 'flex', gap: 6 }}>
                                                                            <Chip
                                                                                variant="outlined"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: '#DDDDDD00',
                                                                                    color: '#BF1D2D',
                                                                                    border: '1px solid #BF1D2D'
                                                                                }}
                                                                                avatar={
                                                                                    <Avatar
                                                                                        src="/images/red-cross.png"
                                                                                        style={{ width: 24, height: 24, padding: 4 }}
                                                                                    />
                                                                                }
                                                                                label="No"
                                                                            />

                                                                            <Chip
                                                                                variant="outlined"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: '#DDDDDD00',
                                                                                    color: '#2B3F6C',
                                                                                    border: '1px solid #2B3F6C80'
                                                                                }}
                                                                                avatar={
                                                                                    <Avatar
                                                                                        src="/images/check1.png"
                                                                                        style={{ width: 24, height: 24, padding: 5 }}
                                                                                    />
                                                                                }
                                                                                label="Yes"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div style={{ color: '#999', textAlign: 'center', padding: '30px 0' }}>
                                        No checklist items found.
                                    </div>
                                )}
                            </div>

                        </Grid>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}

export default MyStationChecklist;